import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "card mb-3" }
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = { class: "table table-sm mb-2" }
const _hoisted_4 = { class: "text-end" }
const _hoisted_5 = { class: "text-end" }
const _hoisted_6 = { class: "badge bg-warning" }
const _hoisted_7 = { class: "text-end" }
const _hoisted_8 = {
  key: 0,
  class: "badge bg-success"
}
const _hoisted_9 = {
  key: 1,
  class: "badge bg-secondary"
}
const _hoisted_10 = { class: "text-end" }
const _hoisted_11 = { class: "text-end" }
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = { class: "text-end" }
const _hoisted_15 = {
  class: "text-end",
  style: {"font-size":"12px"}
}

import moment from "moment";
import {computed} from "vue";
import {IRequestCar} from "@/interfaces/IRequestCar";


export default /*@__PURE__*/_defineComponent({
  __name: 'EventCard',
  props: {
    event: {},
    statusFormat: { type: Function }
  },
  emits: ['event:openRouteModal'],
  setup(__props: any, { emit: __emit }) {

const normalizeDate = (date: string, format: string) => {
  return moment(date).format(format);
}

const emits = __emit;

const openRoute = (id: number) => {
  emits('event:openRouteModal', id)
};

// eslint-disable-next-line vue/valid-define-props
const props = __props;

const startDate = computed((): string => {
  if (props.event.technics) {
    // @ts-ignore
    return moment(props.event.technics[0].treads[0].start_date).format('HH:mm');
  }

  return '';
});

const endDate = computed((): string => {
  if (props.event.technics) {
    // @ts-ignore
    return moment(props.event.technics[0].treads[props.event.technics[0].treads.length - 1].end_date).format('HH:mm');
  }

  return ''
});

const companies = computed((): string => {
  return props.event.company
});

const departments = computed((): string => {
  return props.event.departments;
});


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("table", _hoisted_3, [
        _createElementVNode("tbody", null, [
          _createElementVNode("tr", null, [
            _cache[1] || (_cache[1] = _createElementVNode("td", null, "№ Запроса", -1)),
            _createElementVNode("td", _hoisted_4, _toDisplayString(props.event.id), 1)
          ]),
          _createElementVNode("tr", null, [
            _cache[2] || (_cache[2] = _createElementVNode("td", null, "Статус", -1)),
            _createElementVNode("td", _hoisted_5, [
              _createElementVNode("span", _hoisted_6, _toDisplayString(props.statusFormat(props.event.status)), 1)
            ])
          ]),
          _createElementVNode("tr", null, [
            _cache[3] || (_cache[3] = _createElementVNode("td", null, "Подтверждение", -1)),
            _createElementVNode("td", _hoisted_7, [
              (props.event.partnerAgreeDate)
                ? (_openBlock(), _createElementBlock("span", _hoisted_8, " Вы подтвердили объемы "))
                : (_openBlock(), _createElementBlock("span", _hoisted_9, "Объемы не подтверждены"))
            ])
          ]),
          _createElementVNode("tr", null, [
            _cache[4] || (_cache[4] = _createElementVNode("td", null, "Дата", -1)),
            _createElementVNode("td", _hoisted_10, _toDisplayString(normalizeDate(props.event.date, 'DD.MM.YYYY')), 1)
          ]),
          _createElementVNode("tr", null, [
            _cache[5] || (_cache[5] = _createElementVNode("td", null, "Техника", -1)),
            _createElementVNode("td", _hoisted_11, _toDisplayString(props.event.technics.length ? (props.event.technics[0].car?.car_name || props.event.carTypeName) : ''), 1)
          ]),
          _createElementVNode("tr", null, [
            _cache[6] || (_cache[6] = _createElementVNode("td", null, "Предприятие", -1)),
            _createElementVNode("td", {
              class: "text-end",
              innerHTML: companies.value
            }, null, 8, _hoisted_12)
          ]),
          _createElementVNode("tr", null, [
            _cache[7] || (_cache[7] = _createElementVNode("td", null, "Участок", -1)),
            _createElementVNode("td", {
              class: "text-end",
              innerHTML: departments.value
            }, null, 8, _hoisted_13)
          ]),
          _createElementVNode("tr", null, [
            _cache[8] || (_cache[8] = _createElementVNode("td", null, "Время", -1)),
            _createElementVNode("td", _hoisted_14, _toDisplayString(startDate.value) + " - " + _toDisplayString(endDate.value), 1)
          ]),
          _createElementVNode("tr", null, [
            _cache[9] || (_cache[9] = _createElementVNode("td", null, "Маршрут", -1)),
            _createElementVNode("td", _hoisted_15, [
              _createElementVNode("a", {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (openRoute(props.event.id))),
                href: "javascript:void(0)",
                class: "text-decoration-none fs-6"
              }, " Нажмите для просмотра ")
            ])
          ])
        ])
      ]),
      _createVNode(_component_router_link, {
        to: {name: 'event', params: {id: props.event.id}}
      }, {
        default: _withCtx(() => _cache[10] || (_cache[10] = [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-primary w-100"
          }, " Открыть ", -1)
        ])),
        _: 1
      }, 8, ["to"])
    ])
  ]))
}
}

})